module.exports = __webpack_public_path__ + "static/media/order_confirmation_french_v2.1e07b512.png";